(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Un ÚNICO listener delegado en `document`, no uno por tarjeta: la página de favoritos inyecta
     las tarjetas por JS y un listener puesto al renderizar no las alcanzaría. */
  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest('[data-pc-prev], [data-pc-next]');
    if (!boton) return;

    /* La tarjeta entera es un enlace: sin esto, tocar la flecha se iría a la ficha. */
    ev.preventDefault();
    ev.stopPropagation();

    var media = boton.closest('[data-pc-media]');
    var tarjeta = boton.closest('.product-card');
    if (!media || !tarjeta) return;

    var capas = media.querySelectorAll('[data-pc-capa]');
    var total = capas.length + 1;           /* +1: la foto principal no lleva capa propia */
    if (total < 2) return;

    var actual = parseInt(media.dataset.pcIndice || '1', 10);
    var paso = boton.hasAttribute('data-pc-next') ? 1 : -1;
    var siguiente = ((actual - 1 + paso) % total + total) % total + 1;

    media.dataset.pcIndice = String(siguiente);
    tarjeta.classList.add('pc-manual');
    Array.prototype.forEach.call(capas, function (c) {
      c.classList.toggle('pc-activa', c.dataset.pcCapa === String(siguiente));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
